import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import elementExists from "../../utils/elementExists";

const MiniNav = function () {
    const miniNav = document.querySelector('#mini-nav');

    // Smooth scrolling
    // document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    //     anchor.addEventListener('click', function (e) {
    //         e.preventDefault();
    //         document.querySelector(this.getAttribute('href')).scrollIntoView({
    //             behavior: 'smooth'            
    //         });
    //     });
    // });
    
    if ( elementExists(miniNav) ) {
        gsap.registerPlugin(ScrollTrigger);
    
        let linksArray = document.querySelectorAll('.mini-nav__link');
        let sections = document.querySelectorAll('.gsap-mininav');
        
        if ( elementExists(sections, true) ) {
            sections.forEach((section, i) => {
                let timeline = gsap.timeline({
                    scrollTrigger: {
                        trigger: section,
                        start: "0% 30%",
                        end: "100% 30%",
                        scrub: 0.5,
                        // markers: true,
                    }
                });
                timeline.from(
                    linksArray[i],
                    {
                        classList: 'mini-nav__link header-6 mb-3',
                        duration: 0.1,
                        repeat: 1, 
                        yoyo: true
                    }   
                );
                timeline.to(
                    linksArray[i],
                    {
                        classList: 'mini-nav__link header-6 mb-3 active',
                        duration: 1,
                        repeat: 1, 
                        yoyo: true
                    }   
                );
                timeline.to(
                    linksArray[i],
                    {
                        classList: 'mini-nav__link header-6 mb-3',
                        duration: 0.1,
                        repeat: 1, 
                        yoyo: true
                    }   
                );
            });
        }
    }
}

export default MiniNav;
